import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import Loader from 'components/atoms/loader';

import history from 'services/history';
import Login from 'components/organisms/login_page';
import { refreshProfile } from 'store/modules/profile_store/actions';

const SignIn: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: ProfileTypes.UPDATE_STORE_FIELDS });
    dispatch(refreshProfile());
  }, []);

  const { profile, refresh_request } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );

  if (refresh_request?.loading)
    return (
      <div
        className="d-flex mx-auto justify-content-center align-items-center"
        style={{ height: '70vh ' }}
      >
        <Loader />
      </div>
    );

  if (profile.isSigned) history.push('/');

  return <Login />;
};

export default SignIn;
